import { ApplicationState } from '../index';

import { AuditWorkpaperSummary } from '../../Models/Api/strongbox.financialportal';

/**
 * The set of audit workpapers currently loaded in the store.
 */
export function GetAuditWorkpapers(state: ApplicationState): AuditWorkpaperSummary[] {
    return (state && state.auditWorkpapers) ? state.auditWorkpapers.workpapers : [];
}

/**
 * Whether the audit workpapers have been loaded at least once.
 */
export function AuditWorkpapersLoaded(state: ApplicationState): boolean {
    return (state && state.auditWorkpapers) ? state.auditWorkpapers.loaded : false;
}

/**
 * Whether a load of the audit workpapers is currently in flight.
 */
export function AuditWorkpapersLoading(state: ApplicationState): boolean {
    return (state && state.auditWorkpapers) ? state.auditWorkpapers.loading : false;
}

/**
 * How many years back the audit year may be selected (bounds the audit-year date picker). Defaults to 8.
 */
export function GetMaxAuditYearsBack(state: ApplicationState): number {
    return (state && state.auditWorkpapers) ? state.auditWorkpapers.maxAuditYearsBack : 8;
}
